export default __webpack_public_path__ + "static/media/placeholder_private01-nl-mobile.8ac832ac.png";